import styled from '@emotion/styled'
import { calcRem } from '../../__styling'

export interface StyledIconZapProps {
    stroke?: string
    width?: number
    height?: number
}

export const StyledIconZap = styled('svg')<StyledIconZapProps>(
    ({ stroke, width = 16, height = 16 }) => ({
        width: calcRem(width),
        height: calcRem(height),
        stroke,
    }),
)
